import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-btn-primary-blue',
  templateUrl: './btn-primary-blue.component.html',
  styleUrls: ['./btn-primary-blue.component.css']
})
export class BtnPrimaryBlueComponent implements OnInit {

  @Output() callOnClick: EventEmitter<string> = new EventEmitter();
  @Input() btnLabel: string;
  @Input() isDisabled: string;
  @Input() routingUrl: string;

  constructor() { }

  ngOnInit() {
  }

  onBtnClick(): boolean {
    if (this.isDisabled === 'true') {
      return false;
    }
    // alert('clicked btn in child component');
    this.callOnClick.emit();
    return true;
  }

}
